export const AUDIO_FILE_PATH = '//fiverr-res.cloudinary.com/video/upload/t_fiverr_audio/kxzjjjzyhrqqo65doz60';
export const RT_BROADCAST_CHANNEL = 'pinned_flashes::channel';
export const ECHO_TABS = '__ECHO_TABS__';
export const ECHO_TABS_RESPONSE = '__ECHO_TABS_RESPONSE__';
export const ON_ECHO_REPORTED_FN_NAME = 'onEchoReportEnd';
export const THROTTLE_SOUND = 1000;
